import Cell from './Cell';

type TestResultClassificationProps = {
  score: number | null;
};

const TestResultClassification = ({ score, ...props }: TestResultClassificationProps) => {
  if (score === null) {
    return <Cell {...props}>-</Cell>;
  }
  return (
    <Cell score={score === 1 ? 100 : 0} {...props}>
      {score === 1 ? 'Aprovado' : 'Reprovado'}
    </Cell>
  );
};

export default TestResultClassification;
